<script >
import ChartingSidebarPanelAnalysis from '@/features/charting-next/components/workspace/sidebar/ChartingSidebarPanelAnalysis.vue';
import ChartingSidebarPanelFundamental from '@/features/charting-next/components/workspace/sidebar/ChartingSidebarPanelFundamental.vue';
import { computed, ref, watchEffect } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  stock: {
    type: Object,
    default: null
  },
  fundamentalResource: {
    type: Object,
    default: () => ({})
  },
  hasSelectedTicker: {
    type: Boolean,
    default: true
  },
  canViewBasicInsights: {
    type: Boolean,
    default: false
  },
  canUseFundamental: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const activeView = ref('eurekers');
  const views = computed(() => [{
    key: 'eurekers',
    label: 'Eurekers',
    enabled: props.canViewBasicInsights
  }, {
    key: 'fundamental',
    label: 'Fundamental',
    enabled: props.canUseFundamental
  }].filter(view => view.enabled));
  watchEffect(() => {
    if (!views.value.some(view => view.key === activeView.value)) {
      activeView.value = views.value[0]?.key || 'eurekers';
    }
  });
  return {
    activeView,
    views
  };
};
__sfc_main.components = Object.assign({
  ChartingSidebarPanelAnalysis,
  ChartingSidebarPanelFundamental
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <div class="charting-analysis-panel">
        <div v-if="views.length > 1" class="charting-analysis-panel__switcher" aria-label="Tipo de análisis">
            <button v-for="view in views" :key="view.key" type="button" class="charting-analysis-panel__switcher-button" :class="{ 'is-active': activeView === view.key }" :aria-pressed="activeView === view.key" @click="activeView = view.key">
                {{ view.label }}
            </button>
        </div>

        <div class="charting-workspace-inspector__panel-body charting-analysis-panel__content">
            <ChartingSidebarPanelAnalysis v-if="activeView === 'eurekers'" :stock="stock" />
            <ChartingSidebarPanelFundamental v-else-if="activeView === 'fundamental'" :resource="fundamentalResource" :has-selected-ticker="hasSelectedTicker" />
            <div v-else class="brand-empty-state rounded-xl border border-dashed p-4 text-sm">No hay análisis disponible para este ticker.</div>
        </div>
    </div>
</template>

<style scoped>
.charting-analysis-panel {
    display: flex;
    min-height: 0;
    flex: 1 1 auto;
    flex-direction: column;
    gap: 1rem;
}

.charting-analysis-panel__switcher {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.35rem;
    flex: 0 0 auto;
    border: 1px solid var(--charting-b-border-color, rgba(148, 163, 184, 0.22));
    border-radius: 0.9rem;
    padding: 0.25rem;
    background: var(--charting-b-panel-bg-strong, rgba(255, 255, 255, 0.92));
}

.charting-analysis-panel__switcher-button {
    min-width: 0;
    border: 0;
    border-radius: 0.7rem;
    padding: 0.55rem 0.7rem;
    background: transparent;
    color: var(--p-text-muted-color);
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1.1;
    cursor: pointer;
}

.charting-analysis-panel__switcher-button.is-active {
    background: var(--p-primary-color);
    color: var(--p-primary-contrast-color);
}

.charting-analysis-panel__content {
    flex: 1 1 auto;
}
</style>
